  <template>
  <div class="dem-edi-fin">
    <div class="item-titulo">
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Financeiro
    </div>

    <div class="item-conteudo">
      <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
      <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

      <!-- TELA SEM FINANCEIRO -->
      <template v-else-if="cpntFinStatus !== 's'">
        <!-- SETA OS ERROS QUE DEVEM SER CORRIGIDO PARA COLOCAR NO FINANCEIRO -->
        <div v-if="erros.length >= 1" class="erros">
          <div v-for="(erro, index) in erros" :key="'erro--' + index">
            <!-- SET ICONE DO ERRO -->
            <App-Icone :cpntTipo="erro.icone"></App-Icone>

            <!-- SETA A MENSAGEM DO ERRO -->
            <span style="margin-left: 5px;" v-html="erro.mensagem"></span>
          </div>
        </div>

        <!-- SETA A TELA DE REGISTRAR RECEITA/DESPESA -->
        <App-Financeiro-Registrar-Receita-Despesa v-else :data-time='time' :key="('dem-' + cpntDemanda) + ('demNum-' + cpntDemandaId) + ('val-' + cpntDemandaTotal.geral.liquido) + ('data-' + cpntDemData) + ('df-' + cpntPDocNFEmitida) + ('ser-' + cpntDemandaTotal.servico.item)"
        :cpntTipo="cpntDemanda"
        :cpntRefId="cpntDemandaId"
        :cpntDemandaDados="{ vcto: cpntDemData, status_fin: (cpntFinStatus === 's' ? '1' : '0'), virtual_total: cpntDemandaTotal, id_rec: cpntRecorrencia }"
        :cpntOnAtualizaDados='demEditarFinAtualizarDadosVenda'
        ></App-Financeiro-Registrar-Receita-Despesa>
      </template>

      <!-- TELA COM FINANCEIRO -->
      <div v-else-if="cpntFinStatus === 's'" class="dem-edi-com-fin">
        <!-- SETA O TITULO -->
        <div class="titulo" >        
          Parcelas registradas no Financeiro
        </div>

        <!-- SETA A TELA DE PESQUISA E RELATORIO -->
        <App-Financeiro-Relatorios :key="('dem-' + cpntDemanda) + ('demNum-' + cpntDemandaId)"
        :cpntDemanda="cpntDemanda"
        :cpntDemandaId="cpntDemandaId"
        :cpntMostrarTaxas="false"
        ></App-Financeiro-Relatorios>

        <!-- SETA O BOTÃO DE REMOVER DO FINANCEIRO -->
        <div class="remover">
          <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick="demEditarFinRemoverParcelas"><span v-html="demEditarFinFraseBotaoRemover()"></span></App-Button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dem-edi-fin {
  margin-top: 10px;
}
  .dem-edi-fin > .item-conteudo > .erros {
    text-align: center;
    margin-bottom: 10px;
  }

  .dem-edi-fin > .item-conteudo > .dem-edi-com-fin > .titulo {
    color: #1b7882;
    text-align: center;
    margin-bottom: 10px;
  }
  .dem-edi-fin > .item-conteudo > .dem-edi-com-fin > .remover {
    margin-top: 10px;
    text-align: right;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },

      cpntDemData: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntFinStatus: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntSDocTp: {
        required: true
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntSDocNFEmitida: {
        required: true
      },
      cpntRecorrencia: {
        required: true
      }
    },
    components: {
      'App-Financeiro-Registrar-Receita-Despesa': () => import('@/components/financeiro/Registrar/Financeiro-Registrar-Receita-Despesa.vue'),
      'App-Financeiro-Relatorios': () => import('@/components/financeiro/Relatorio/Financeiro-Relatorios.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        remover: '',
        erros: []
      }
    },
    mounted: function () {
      this.demEditarFinIniciar()
    },
    methods: {
      demEditarFinIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEditarFinSetarStatusGeral('carregando')

        // MONTA OS ERROS DO FINANCEIRO
        this.demEditarFinBuscarErrosFinancerio(() => { this.demEditarFinSetarStatusGeral('') })
      },
      demEditarFinSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEditarFinAtualizarDadosVenda: function () {
        // DESTRAVA A TELA
        this.$emit('DEMANDA_TRAVAR_TELA', false)

        // ATUALIZA OS DADOS E DESTRAVA A TELA
        this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
      },
      demEditarFinBuscarErrosFinancerio: function (callback = null) {
        if (this.cpntFinStatus !== 's') {
          // INICIA O QUERYGET DO CMAPO
          var queryGet = [ this.cpntDemandaId ]

          // INICIA A VARIAVEL DA ROTA
          var router = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'venda':
              router = '/venda/financeiro/chk-post/get/'
              break

            case 'compra':
              router = '/demanda/dem-compra/financeiro/chk-post/get/'
              break
          }

          // BUSCA OS DADOS NA API
          this.$store.state.comunicaAPI(router, 'GET', queryGet, (retorno) => {
            // PEGA OS DADOS DO LOT
            retorno = retorno.lot[0]

            // INICIA A VARIAVEL DE ERRO
            var erros = []
            var erro = ''

            // VERIFICA SE DEU ALGUM ERRO
            switch (retorno) {
              case '200':
                break

              case '406':
                erro = { icone: 'alerta-amarelo', mensagem: '' }
                break

              default:
                erro = { icone: 'erro-vermelho', mensagem: '' }
                break
            }

            // VERIFICA SE TEM ALGUM ERRO
            if (erro !== '') {
              // VERIFICA O TIPO DA MENSAGEM
              if (typeof retorno.message === 'string') {
                // SETA A MENSAGEM RECEBIDA
                erro.mensagem = retorno.message
  
                // ADICIONA O ERRO AO VETOR
                erros.push(JSON.parse(JSON.stringify(erro)))
              } else {
                for (var indexM in retorno.message) {
                  // SETA A MENSAGEM RECEBIDA
                  erro.mensagem = retorno.message[indexM]

                  // ADICIONA O ERRO AO VETOR
                  erros.push(JSON.parse(JSON.stringify(erro)))
                }
              }
  
              // SETA O VALOR MONTADO
              this.erros = erros
            }

            // EXECUTA O CALLBACK RECEBIDO
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }, this.demEditarFinSetarStatusGeral)
        } else if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      demEditarFinRemoverParcelas: function () {
        if (confirm('Confirma a exclusão de todas as parcelas desta venda do financeiro?')) {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // INICIA O VETOR
          var formData = { modulo: '', id_mod_reg: this.cpntDemandaId }

          // SETA O MODULO QUE ESTÁ GERANDO ESSA INFORMAÇÃO
          switch (this.cpntDemanda) {
            case 'compra':
              formData.modulo = 'dem_compra'
              break

            case 'venda':
              formData.modulo = 'venda'
              break
          }

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ { ref: formData } ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/financeiro', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR AS INFORMAÇÕES DO MENU
                this.$store.commit('SET_INFO_MENU')
      
                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$emit('DEMANDA_BUSCAR_VALORES', () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
                break
            }
          }, this.demEditarFinSetarStatusGeral)
        }
      },
      demEditarFinFraseBotaoRemover: function () {
        switch (this.cpntDemanda) {
          case 'compra':
            return 'Remover Compra do Financeiro'

          case 'venda':
            return 'Remover Venda do Financeiro'
        }
      }
    },
    watch: {
      cpntDemandaId: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      cpntFinStatus: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      cpntPDocTp: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      cpntSDocTp: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      cpntPDocNFEmitida: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      cpntSDocNFEmitida: function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      'cpntDemandaTotal.geral.liquido': function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      'cpntDemandaTotal.produto.item': function () {
        this.demEditarFinBuscarErrosFinancerio()
      },
      'cpntDemandaTotal.servico.item': function () {
        this.demEditarFinBuscarErrosFinancerio()
      }
    }
  }
</script>
